export default "__VITE_ASSET__HPOYy3F3__"